import { Pipe, PipeTransform } from '@angular/core';

import { Filter } from 'app/modules/collection/services/filter.service';

@Pipe({
  name: 'sectionFilter',
  standalone: true,
})
export class SectionFilterPipe implements PipeTransform {
  transform(filters: Filter[], forSection: boolean): Filter[] {
    if (forSection) {
      return filters.filter((f) => f.sectionField || f.selectedSections?.length);
    }

    return filters.filter((f) => !f.sectionField && !f.selectedSections?.length);
  }
}
